//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vComponent from '@/core/vComponent'
import { mapGetters } from 'vuex'
import { setLocal } from '@/utils/globalState'
import { searchVipBar } from './components'
import moment from 'moment'
export default {
  name: 'ListPage',
  extends: vComponent,
  components: { searchVipBar },
  data () {
    return {
      options: [
        { label: '姓名', key: 'VIP_NAME' },
        { label: '電話', key: 'VIP_TEL' },
        { label: '生日', key: 'VIP_BIRTHDAY' },
        { label: '會員備註', key: 'VIP_MEMO' }
      ],
      selectedLabel: '請選擇',
      items: [], // 取得的資料
      meta: {},
      columns: [ // 欄位宣告
      ],
      subPages: [
        { id: 'transaction', label: '交易', icon: 'dashboard' },
        { id: 'ticket', label: '兌換卷', icon: 'payment' }
        /* { id: 'report', label: '分析', icon: 'trending_up' },
        { id: 'tag', label: '註記', icon: 'edit' },
        { id: 'recommend', label: '推薦', icon: 'thumb_up' } */
      ],
      pagination: {
        page: 1, // 目前第幾頁
        rowsPerPage: 50, // 每頁幾筆
        rowsNumber: 20 // 總筆數
      },
      queryParams: { // 查詢條件
        key: null,
        val: null
      },
      // 新增vip
      isShowCheckModal: false, // 是否顯示檢查電話modal
      inputVipTel: ''
    }
  },
  computed: {
    ...mapGetters([
      'builderHost',
      'dateFormat',
      'site'
    ]),
    isTelValid () {
      if (this.inputVipTel === '' || this.inputVipTel.length !== 10) return false
      const reg = new RegExp(/^\d+$/)
      return reg.test(this.inputVipTel)
    },
    hintInfo () {
      return this.isTelValid ? '電話號碼' : '請輸入正確手機號碼（10碼）'
    }
  },
  async created () {
    // url query有帶資料 直接查
    if (this.query.key !== undefined && this.query.val !== undefined) {
      this.queryParams.key = this.query.key
      this.queryParams.val = this.query.val
    }
    await this.doQuery()
  },
  mounted () {
    this.addHandler()
  },
  methods: {
    addHandler () {
      this.on('SearchVipBar.Search', (obj) => {
        this.queryParams = obj
        this.doQuery(obj.key, obj.val)
      })
    },
    clickBtn (row, type) {
      setLocal('currentVip', row)
      // const url = `/vip/${row.ID_NO}/${type}/${row.VIP_CODE}`
      const url = type === 'transaction' ? `/vip/${row.ID_NO}/${type}/${row.VIP_CODE}` : `/vip/${row.ID_NO}/${type}`
      this.to(url)
    },
    async doQuery () {
      const data = { SITE: this.site }
      if (this.queryParams.key !== null) data[this.queryParams.key] = `%${this.queryParams.val}%`
      data.countPerPage = this.pagination.rowsPerPage
      data.currentPage = this.pagination.page
      const response = await this.fetch('builderApi', this.builderHost, 'crmvipmf', data)
      this.items = response.data !== null ? response.data : []
      this.meta = response.meta
      this.pagination.rowsNumber = this.meta.total
      this.items.forEach(item => {
        if (item.BIRTHDAY === null) item.BIRTHDAY = '使用者未提供'
      })
    },
    formatBirth (str) {
      return moment(str, 'YYYYMMDD').format(this.dateFormat)
    },
    async onRequest (props) {
      const { page, rowsPerPage } = props.pagination
      // const filter = props.filter
      this.pagination.page = page
      this.pagination.rowsPerPage = rowsPerPage
      console.log('on request props=')
      console.log(props)
      await this.doQuery()
    },
    clickRow (row) {
      setLocal('currentVip', row)
      this.to(`/vip/${row.ID_NO}/info/${row.VIP_CODE}`)
    },
    // 新增會員
    clickAddVip () {
      // 先清除 再顯示
      this.inputVipTel = ''
      this.isShowCheckModal = true
    },
    // 執行電話檢查
    async clickConfirm () {
      console.log(`do check!! site=${this.site}`)
      const data = { VERIFY_ID: this.inputVipTel }
      const response = await this.fetch('checkMobileCloud', this.site, data)
      console.log(response)
      if (response.result === 'OK') {
        if (response.data === 'exist') {
          this.alert(`電話 ${this.inputVipTel} 已註冊過`)
        } else {
          // this.alert(`執行新增帳號 ${this.inputVipTel}`)
          await this.registerMember(this.inputVipTel)
        }
      } else {
        this.alert('檢查失敗')
      }
    },
    async registerMember (verifyID) {
      const data = {
        SITE: this.site,
        VERIFY_ID: verifyID,
        SRC: 4
      }
      const response = await this.fetch('registerByVerifyID', data)
      if (response.result === 'OK') {
        this.alert(`${this.inputVipTel} 註冊完成`, () => {
          const ID_NO = response.data.ID_NO
          setLocal('currentVip', response.data)
          const url = `/vip/${ID_NO}/info/${response.data.VIP_CODE}`
          this.to(url)
        })
      } else {
        this.alert('註冊失敗')
      }
    },
    alert (message, callback = null) {
      this.$q.dialog({
        // title,
        message
      }).onOk(() => {
        console.log('run on ok!!')
        this.isShowCheckModal = false
        if (callback !== null) callback()
      })
    }
  }
}
